// projects/humanresources-general/src/assets/i18n/*/hr-gen-certificate.json
export class HrGenCertificateKey {
    private static readonly keyPrefix = 'hrGenCertificate';
    public static title = `${HrGenCertificateKey.keyPrefix}.title`;
    public static pageHeader = `${HrGenCertificateKey.keyPrefix}.pageHeader`;
    public static documentType = `${HrGenCertificateKey.keyPrefix}.documentType`;
    public static educationPlace = `${HrGenCertificateKey.keyPrefix}.educationPlace`;
    public static educationPlaceText = `${HrGenCertificateKey.keyPrefix}.educationPlaceText`;
    public static measureUnitUuid = `${HrGenCertificateKey.keyPrefix}.measureUnitUuid`;
}
